import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const isMockAdyenOnboardingPage = (search: string): boolean =>
  new URLSearchParams(search).has('mockAdyenOnboarding');

export function MockAdyenOnboarding() {
  const { t } = useTranslation();

  useEffect(() => {
    const previousTitle = window.document.title;
    window.document.title = t('mockAdyenOnboarding.pageTitle');
    return () => {
      window.document.title = previousTitle;
    };
  }, [t]);

  return (
    <main className="min-vh-100 bg-light d-flex align-items-center justify-content-center p-3 p-sm-4">
      <section
        className="card border-0 shadow-sm w-100 overflow-hidden"
        style={{ maxWidth: 640 }}
        aria-labelledby="mock-adyen-onboarding-title"
      >
        <header className="card-header bg-white border-bottom d-flex align-items-center justify-content-between gap-3 px-4 py-3">
          <img src="/assets/images/logo-full.png" alt="ETAPPIO" height="34" />
          <span className="badge bg-warning text-dark">
            {t('mockAdyenOnboarding.badge')}
          </span>
        </header>

        <div className="card-body text-center px-4 py-5 p-sm-5">
          <div
            className="bg-warning bg-opacity-10 text-warning rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
            style={{ width: 72, height: 72 }}
            aria-hidden="true"
          >
            <i className="feather-alert-triangle fs-2"></i>
          </div>

          <h1 id="mock-adyen-onboarding-title" className="h3 fw-bold mb-3">
            {t('mockAdyenOnboarding.title')}
          </h1>
          <p className="text-muted mb-4">
            {t('mockAdyenOnboarding.description')}
          </p>

          <div className="alert alert-light border text-start mb-4" role="note">
            <div className="d-flex gap-3">
              <i className="feather-info text-primary mt-1" aria-hidden="true"></i>
              <span>{t('mockAdyenOnboarding.explanation')}</span>
            </div>
          </div>

          <Link
            className="btn btn-primary px-4"
            to="/settings/company?tab=adyen"
            replace
          >
            <i className="feather-arrow-left me-2" aria-hidden="true"></i>
            {t('mockAdyenOnboarding.back')}
          </Link>
        </div>

        <footer className="card-footer bg-white border-top text-center text-muted small px-4 py-3">
          <i className="feather-lock me-2" aria-hidden="true"></i>
          {t('mockAdyenOnboarding.footer')}
        </footer>
      </section>
    </main>
  );
}
